import * as PIXI from 'pixi.js'
import { getItem } from '@/utils/Utils.js'
import loadImage from 'image-promise'

const btnSize = 30
const initSize = 50
const minSize = 10

class MyPIXIImage {
  async load (base64, data) {
    // console.log('image load', base64, data)
    this._type = 'image'
    const container = new PIXI.Container()

    if (data) {
      container.x = data.x
      container.y = data.y
      container.angle = data.angle
    } else {
      container.x = 0
      container.y = 0
    }

    const image = new Image()
    if (data) {
      base64 = await getItem(data.name)
    }
    image.src = base64
    await loadImage(image)
    const sprite = new PIXI.Sprite(PIXI.Texture.from(image))
    this.sprite = sprite
    sprite.anchor.set(0.5)
    if (data) {
      sprite.width = data.width
      sprite.height = data.height
    } else {
      if (image.width < image.height) {
        sprite.width = initSize
        sprite.height = image.height / image.width * sprite.width
      } else {
        sprite.height = initSize
        sprite.width = image.width / image.height * sprite.height
      }
    }
    sprite.interactive = true
    sprite.on('pointerdown', (e) => {
      if (this.select) {
        this.select(this)
      }
      this._dragging = true
      frame.visible = true
      sprite._x = container.x
      sprite._y = container.y
      sprite._startx = e.data.getLocalPosition(sprite.parent.parent).x
      sprite._starty = e.data.getLocalPosition(sprite.parent.parent).y
    })
    sprite.on('pointermove', (e) => {
      if (!this._dragging) return
      const x = e.data.getLocalPosition(sprite.parent.parent).x
      const y = e.data.getLocalPosition(sprite.parent.parent).y
      container.x = sprite._x + x - sprite._startx
      container.y = sprite._y + y - sprite._starty
      if (this.update) {
        this.update()
      }
    })
    sprite.on('pointerup', () => {
      this._dragging = false
    })
    sprite.on('pointerupoutside', () => {
      this._dragging = false
      frame.visible = false
    })
    container.addChild(sprite)

    const frame = new PIXI.Container()
    frame.visible = false
    this._frame = frame
    container.addChild(frame)

    // 0-红线框
    const lineContainer = new PIXI.Container()
    frame.addChild(lineContainer)
    const line = new PIXI.Graphics()
    line.lineStyle(2, 0xffffff, 1)
    line.moveTo(-sprite.width * 0.5, -sprite.height * 0.5)
    line.lineTo(-sprite.width * 0.5, sprite.height * 0.5)
    line.lineTo(sprite.width * 0.5, sprite.height * 0.5)
    line.lineTo(sprite.width * 0.5, -sprite.height * 0.5)
    line.lineTo(-sprite.width * 0.5, -sprite.height * 0.5)
    lineContainer.addChild(line)

    // 1
    const removeLineContainer = new PIXI.Container()
    frame.addChild(removeLineContainer)
    const removeLine = new PIXI.Graphics()
    removeLine.lineStyle(2, 0xffffff, 1)
    removeLine.moveTo(-sprite.width * 0.5, 0)
    removeLine.lineTo(-sprite.width * 0.5 - btnSize * 0.75, 0)
    removeLineContainer.addChild(removeLine)

    // 2
    const removeBG = PIXI.Sprite.from('./circle.svg')
    removeBG.tint = 0x0485d5
    removeBG.anchor.set(0.5)
    removeBG.width = btnSize
    removeBG.height = btnSize
    removeBG.x = -sprite.width * 0.5 - btnSize * 0.75
    removeBG.y = 0
    removeBG.interactive = true
    removeBG.on('pointerdown', () => {
      container.visible = false
      this.visible = false
      if (this.remove) {
        this.remove()
      }
    })
    frame.addChild(removeBG)

    // 3
    const remove = PIXI.Sprite.from('./delete.svg')
    remove.anchor.set(0.5)
    remove.width = btnSize * 0.5
    remove.height = btnSize * 0.5
    remove.x = -sprite.width * 0.5 - btnSize * 0.75
    remove.y = 0
    frame.addChild(remove)

    // 4
    const zoomLineContainer = new PIXI.Container()
    const zoomLine = new PIXI.Graphics()
    zoomLineContainer.addChild(zoomLine)
    zoomLine.lineStyle(2, 0xffffff, 1)
    zoomLine.moveTo(sprite.width * 0.5, 0)
    zoomLine.lineTo(sprite.width * 0.5 + btnSize * 0.75, 0)
    frame.addChild(zoomLineContainer)

    // 5
    const zoomBG = PIXI.Sprite.from('./circle.svg')
    zoomBG.tint = 0x0485d5
    zoomBG.anchor.set(0.5)
    zoomBG.width = btnSize
    zoomBG.height = btnSize
    zoomBG.x = sprite.width * 0.5 + btnSize * 0.75
    zoomBG.y = 0
    zoomBG.interactive = true
    zoomBG.on('pointerdown', (e) => {
      this._zooming = true
      zoomBG._startWidth = sprite.width
      zoomBG._startHeight = sprite.height
      zoomBG._startx = e.data.getLocalPosition(sprite.parent.parent).x
    })
    zoomBG.on('pointermove', (e) => {
      if (!this._zooming) return
      const offset = 1 + (e.data.getLocalPosition(sprite.parent.parent).x - zoomBG._startx) * 0.01
      let width = zoomBG._startWidth * offset
      let height = zoomBG._startHeight * offset
      if (width < minSize) {
        width = minSize
        height = sprite.height / sprite.width * width
      }
      if (height < minSize) {
        height = minSize
        width = sprite.width / sprite.height * height
      }
      sprite.width = width
      sprite.height = height
      this.change()
    })
    zoomBG.on('pointerup', () => {
      this._zooming = false
    })
    zoomBG.on('pointerupoutside', () => {
      this._zooming = false
    })
    frame.addChild(zoomBG)

    // 6
    const zoom = PIXI.Sprite.from('./zoom.svg')
    zoom.anchor.set(0.5)
    zoom.width = btnSize * 0.4
    zoom.height = btnSize * 0.4
    zoom.x = sprite.width * 0.5 + btnSize * 0.75
    zoom.y = 0
    frame.addChild(zoom)

    // 7
    const rotateLineContainer = new PIXI.Container()
    frame.addChild(rotateLineContainer)
    const rotateLine = new PIXI.Graphics()
    rotateLine.lineStyle(2, 0xffffff, 1)
    rotateLine.moveTo(0, -sprite.height * 0.5)
    rotateLine.lineTo(0, -sprite.height * 0.5 - btnSize * 0.75)
    rotateLineContainer.addChild(rotateLine)

    // 8
    const rotateBG = PIXI.Sprite.from('./circle.svg')
    rotateBG.tint = 0x0485d5
    rotateBG.anchor.set(0.5)
    rotateBG.width = btnSize
    rotateBG.height = btnSize
    rotateBG.x = 0
    rotateBG.y = -sprite.height * 0.5 - btnSize * 0.75
    rotateBG.interactive = true
    rotateBG.on('pointerdown', (e) => {
      this._rotating = true
      rotateBG._startAngle = container.angle
      rotateBG._startx = e.data.getLocalPosition(sprite.parent.parent).x
    })
    rotateBG.on('pointermove', (e) => {
      if (!this._rotating) return
      container.angle = rotateBG._startAngle + (e.data.getLocalPosition(sprite.parent.parent).x - rotateBG._startx) * 0.5
      if (this.update) {
        this.update()
      }
    })
    rotateBG.on('pointerup', () => {
      this._rotating = false
    })
    rotateBG.on('pointerupoutside', () => {
      this._rotating = false
    })
    frame.addChild(rotateBG)

    // 9
    const rotate = PIXI.Sprite.from('./rotate.svg')
    rotate.anchor.set(0.5)
    rotate.width = btnSize * 0.5
    rotate.height = btnSize * 0.5
    rotate.x = 0
    rotate.y = -sprite.height * 0.5 - btnSize * 0.75
    frame.addChild(rotate)

    this.container = container
  }

  change () {
    this._frame.getChildAt(0).removeChildAt(0)
    const line = new PIXI.Graphics()
    line.lineStyle(2, 0xffffff, 1)
    line.moveTo(-this.sprite.width * 0.5, -this.sprite.height * 0.5)
    line.lineTo(-this.sprite.width * 0.5, this.sprite.height * 0.5)
    line.lineTo(this.sprite.width * 0.5, this.sprite.height * 0.5)
    line.lineTo(this.sprite.width * 0.5, -this.sprite.height * 0.5)
    line.lineTo(-this.sprite.width * 0.5, -this.sprite.height * 0.5)
    this._frame.getChildAt(0).addChild(line)

    this._frame.getChildAt(1).removeChildAt(0)
    const removeLine = new PIXI.Graphics()
    removeLine.lineStyle(2, 0xffffff, 1)
    removeLine.moveTo(-this.sprite.width * 0.5, 0)
    removeLine.lineTo(-this.sprite.width * 0.5 - btnSize * 0.75, 0)
    this._frame.getChildAt(1).addChild(removeLine)
    this._frame.getChildAt(2).x = -this.sprite.width * 0.5 - btnSize * 0.75
    this._frame.getChildAt(3).x = -this.sprite.width * 0.5 - btnSize * 0.75

    this._frame.getChildAt(4).removeChildAt(0)
    const zoomLine = new PIXI.Graphics()
    zoomLine.lineStyle(2, 0xffffff, 1)
    zoomLine.moveTo(this.sprite.width * 0.5, 0)
    zoomLine.lineTo(this.sprite.width * 0.5 + btnSize * 0.75, 0)
    this._frame.getChildAt(4).addChild(zoomLine)
    this._frame.getChildAt(5).x = this.sprite.width * 0.5 + btnSize * 0.75
    this._frame.getChildAt(6).x = this.sprite.width * 0.5 + btnSize * 0.75

    this._frame.getChildAt(7).removeChildAt(0)
    const rotateLine = new PIXI.Graphics()
    rotateLine.lineStyle(2, 0xffffff, 1)
    rotateLine.moveTo(0, -this.sprite.height * 0.5)
    rotateLine.lineTo(0, -this.sprite.height * 0.5 - btnSize * 0.75)
    this._frame.getChildAt(7).addChild(rotateLine)
    this._frame.getChildAt(8).y = -this.sprite.height * 0.5 - btnSize * 0.75
    this._frame.getChildAt(9).y = -this.sprite.height * 0.5 - btnSize * 0.75

    if (this.update) {
      this.update()
    }
  }

  unhighlight () {
    this._frame.visible = false
  }

  highlight () {
    this._frame.visible = true
  }

  resize (val) {
    if (val == null) return
    this.sprite.width *= val
    this.sprite.height *= val
    this.change()
  }

  move ({ x, y }) {
    this.container.x = x
    this.container.y = y
    this.change()
  }

  rotate (val) {
    this.container.angle = val
    if (this.update) {
      this.update()
    }
  }
}

export default MyPIXIImage
